(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

initSwiper() {
  console.log('🔧 initSwiper running...');

  const swiperContainer = this.querySelector('.products-carousel__slider');
  const swiperNext = this.querySelector('.products-carousel__control-next');
  const swiperPrev = this.querySelector('.products-carousel__control-prev');
  const swiperPagination = this.querySelector('.swiper-pagination');

  console.log('Swiper Elements:', {
    container: swiperContainer,
    next: swiperNext,
    prev: swiperPrev,
    pagination: swiperPagination
  });

  if (!swiperContainer) {
    console.warn('❌ Swiper container not found.');
    return;
  }

  const sizeCardSettings = {
  default: {
    slidesPerView: 1.2,
    spaceBetween: 32,
    breakpoints: {
      [this.breakpoints.desktop]: {
        slidesPerView: 2.75,
        spaceBetween: 48,
      },
    },
  },
  large: {
    slidesPerView: 1.1,
    spaceBetween: 24,
    breakpoints: {
      [this.breakpoints.desktop]: {
        slidesPerView: 3.2,
        spaceBetween: 24,
      },
    },
  },
  compact: {
    slidesPerView: 2,
    spaceBetween: 16,
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 0
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 0
      }
    }
  }
};

  
  
  const mainSettings = {
    navigation: {
      nextEl: swiperNext,
      prevEl: swiperPrev,
    },
    
    pagination: {
      el: swiperPagination,
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return `
          <div class="custom-swiper-pagination">
            <span class="custom-arrow custom-prev${current === 1 ? ' disabled' : ''}">‹</span>
            <span class="custom-arrow custom-next${current === total ? ' disabled' : ''}">›</span>
          </div>
        `;
      }
    },

    speed: 300,
    ...sizeCardSettings[this.cardsSize]
  };

  console.log('✅ Swiper initialized with:', mainSettings);

  this.swiper = new Swiper(swiperContainer, mainSettings);

  this.bindCustomPagination(); // manually call once after init
  this.swiper.on('slideChange', () => this.bindCustomPagination()); // update pagination when sliding


}



    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        this.swiper.destroy(true, true);
      } else {
        this.initSwiper(); // ✅ Re-init using the same logic
      }
    }

    bindCustomPagination() {
    const container = this.querySelector('.swiper-pagination');
    if (!container) return;
  
    container.querySelectorAll('.custom-page').forEach(el => {
      el.addEventListener('click', (e) => {
        const pageIndex = parseInt(e.currentTarget.getAttribute('data-index'), 10);
        this.swiper.slideTo((pageIndex - 1) * this.swiper.params.slidesPerView);
      });
    });
  
    const prev = container.querySelector('.custom-prev');
    const next = container.querySelector('.custom-next');
  
    if (prev) prev.addEventListener('click', () => this.swiper.slidePrev());
    if (next) next.addEventListener('click', () => this.swiper.slideNext());
  }


    
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
